import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")
  const _component_touch = _resolveComponent("touch")

  return ($options.hasSlides)
    ? (_openBlock(), _createBlock(_component_touch, {
        key: 0,
        enabled: $props.canSwipe,
        onSwipeLeft: $options.next,
        onSwipeRight: $options.prev
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            onMouseenter: _cache[0] || (_cache[0] = (...args) => ($options.onMouseEnter && $options.onMouseEnter(...args))),
            onMouseleave: _cache[1] || (_cache[1] = (...args) => ($options.onMouseLeave && $options.onMouseLeave(...args)))
          }, [
            _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps($options.slotProps))),
            _renderSlot(_ctx.$slots, "view", _normalizeProps(_guardReactiveProps({ currentItem: _ctx.currentItem, onAction: $options.onAction }))),
            ($options.hasMoreThanOneSlide)
              ? _renderSlot(_ctx.$slots, "nav", _normalizeProps(_guardReactiveProps({ onNext: $options.onNext, onPrev: $options.onPrev, onAction: $options.onAction })), () => [
                  (!$options.hasControlsSlots)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_base_button, {
                          theme: "white",
                          shape: "circle",
                          shadow: "tight",
                          "aria-label": _ctx.Resources.Common.ScrollLeftButtonLabel,
                          onClick: $options.onPrev,
                          "data-qa": "left-arrow-button"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_base_icon, {
                              name: "chevron-left",
                              class: "_tc--accent",
                              size: "lg"
                            })
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["aria-label", "onClick"]),
                        _createVNode(_component_base_button, {
                          theme: "white",
                          shape: "circle",
                          shadow: "tight",
                          disabled: _ctx.isScrollRightDisabled,
                          "aria-label": _ctx.Resources.Common.ScrollRightButtonLabel,
                          onClick: $options.onNext,
                          "data-qa": "right-arrow-button"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_base_icon, {
                              name: "chevron-right",
                              class: "_tc--accent",
                              size: "lg"
                            })
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["disabled", "aria-label", "onClick"])
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ], undefined, 0)
              : _createCommentVNode("v-if", true),
            _renderSlot(_ctx.$slots, "controls", _normalizeProps(_guardReactiveProps({ onNext: $options.onNext, onPrev: $options.onPrev }))),
            ($options.hasMoreThanOneSlide)
              ? _renderSlot(_ctx.$slots, "indicators", _normalizeProps(_guardReactiveProps({ onSetCurrentIndex: $options.onSetCurrentIndex, currentItem: _ctx.currentItem, indicators: $options.indicators })), undefined, undefined, 1)
              : _createCommentVNode("v-if", true),
            _renderSlot(_ctx.$slots, "actions", _normalizeProps(_guardReactiveProps({ onAction: $options.onAction })))
          ], 32 /* NEED_HYDRATION */)
        ]),
        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["enabled", "onSwipeLeft", "onSwipeRight"]))
    : _createCommentVNode("v-if", true)
}